import { createStore } from 'vuex';
import { HTTP, AUTH, AUTHjwt } from '@/script/http-common'
import jwt_decode from 'jwt-decode'
import router from '../router'


export default createStore({
  state: {
    jwt: {
      access: localStorage.getItem('accessToken'),
      refresh: localStorage.getItem('refreshToken'),
    },
    userProfile: {
      fullname: "",
      company: "",
      role: {
        name: '',
      },
    },
    userBalance: 0,
    userCards: [],
    payoffOrders: [],
    berry: [],
  },

  getters: {
    jwtAccessValid: state => () => {
      let expAccess = (state.jwt.access) ? jwt_decode(state.jwt.access).exp : 0
      return (expAccess - Date.now() / 1000 > 0) ? true : false
    },

    jwtAccess: state => () => {
      let expAccess = (state.jwt.access) ? jwt_decode(state.jwt.access).exp : 0
      return (expAccess - Date.now() / 1000 > 0) ? state.jwt.access : null
    },

    userProfile: state => {
      return state.userProfile
    },

    isDeliverer: state => {
      return (('passport' in state.userProfile) && state.userProfile.passport.lastName) ? true : false
    },

    isReciever: state => {
      return (('receiver' in state.userProfile) && state.userProfile.receiver.fullname) ? true : false
    },

    userName: state => {
      let username = false
      if (Object.keys(state.userProfile).length !== 0) {
        if ('company' in state.userProfile && state.userProfile.company) {
          username = state.userProfile.company
        } else if ('receiver' in state.userProfile && 'fullname' in  state.userProfile.receiver) {
          username = state.userProfile.receiver.fullname
        } else {
          username = (state.userProfile.passport)
            ? `${state.userProfile.passport.firstName} ${state.userProfile.passport.lastName}`
            : state.userProfile.email
        }
      }
      return username
    },

    userCards: state => {
      return state.userCards
    },

    berry: state => {
      return state.berry
    },

    getBerry: state => (berryId) => {
      let index = state.berry.findIndex(item => item._id == berryId)
      let berry = (index >= 0) ? state.berry[index] : null
      return berry
    },

    payoffOrders: state => {
      return state.payoffOrders
    },

    userBalance: state => {
      return state.userBalance
    },

    isAdmin: state => {
      return state.userProfile.role.name == 'admin'
    },
  },

  mutations: {
    updateToken: (state, newToken) => {
      localStorage.setItem('accessToken', newToken.access);
      localStorage.setItem('refreshToken', newToken.refresh);
      state.jwt = newToken;
      console.log('token updated')
    },

    removeToken: (state) => {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      state.jwt.access = null
      state.jwt.refresh = null
    },

    SETuserProfile: (state, userProfile) => {
      state.userProfile = (userProfile == "") ? { company: "", fullname: "" } : userProfile
    },

    SETuserCards: (state, userCards) => {
      console.log('userCards', userCards)
      state.userCards = userCards
    },

    SETberry: (state, berry) => {
      state.berry = berry
    },

    SETuserBalance: (state, balance) => {
      state.userBalance = balance
    },

    SETpayoffOrders: (state, payoffOrders) => {
      console.log('payoffOrders', payoffOrders)
      state.payoffOrders = payoffOrders
    },

    DELuserCardItem: (state, cardId) => {
      let cardIndex = state.userCards.findIndex(item => item._id == cardId)
      if (cardIndex >= 0) {
        state.userCards.splice(cardIndex, 1)
      }
    },
  },

  actions: {
    singup: async ({ dispatch }, payload) => {
      var status, err
      try {
        let response = await AUTH.post('signup/', payload)
        console.log('singup', response)
        if (response.status >= 200 && response.status < 300) {
          status = { success: true, err: '' }
        } else {
          status = { success: false, err: response.data.message }
        }
      } catch (error) {
        //console.log(error.response)
        status = { success: false, err: error.response.data.message }
      }
      return status
    },

    uploadPassport: async ({ getters, dispatch }, payload) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        let formData = new FormData()
        formData.append("main", payload.main)
        formData.append("address", payload.address)

        response = await HTTP(getters.jwtAccess()).post(`upload/passport/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        console.log(error.response)
        data = error.response.data
      }
      return { status: success, data: data }
    },

    
    registerByCode: async ({ commit, dispatch }, payload) => {
      var success, response
      var err = ''
      try {
        response = await AUTH.post('registerByCode/', payload)
        if (response.status >= 200 && response.status < 300) {
          success = true
        } else {
          err = response.data.message
        }
      } catch (error) {
        console.log('error', error)
        success = false
        err = error.response.data.message
      }
      return { success: success, err: err }
    },

    loginByCode: async ({ commit, dispatch }, payload) => {
      var success, response
      var err = ''
      try {
        response = await AUTH.post('loginByCode/', payload)
        if (response.status >= 200 && response.status < 300) {
          commit('updateToken', response.data)
          await dispatch('FETCHuserProfile', { userId: null, phone: null })
          success = true
        } else {
          err = response.data.message
        }
      } catch (error) {
        console.log('error', error)
        success = false
        err = error.response.data.message
      }
      return { success: success, err: err }
    },

    obtainToken: async ({ commit, dispatch }, { username, password }) => {
      const payload = {
        username: username,
        password: password
      }
      var success, response
      var err = ''
      try {
        response = await AUTH.post('signin/', payload)
        if (response.status >= 200 && response.status < 300) {
          commit('updateToken', response.data)
          await dispatch('FETCHuserProfile', { userId: null, phone: null })
          success = true
        } else {
          err = response.data.message
        }
      } catch (error) {
        console.log('error', error)
        success = false
        err = error.response.data.message
      }
      return { success: success, err: err }
    },

    refreshToken: async ({ state, commit }) => {
      const payload = {
        refresh: state.jwt.refresh
      }
      var success
      try {
        let response = await AUTH.post('refreshtoken/', payload)
        if (response.status >= 200 && response.status < 300) {
          commit('updateToken', response.data)
          success = true
        }
      } catch (error) {
        success = false
      }
      return success
    },

    inspectToken: async ({ state, dispatch, commit }) => {
      var success = true
      let expDelay = 900 // 15min
      let expAccess = (state.jwt.access) ? jwt_decode(state.jwt.access).exp : 0
      console.log('----------------------------------------')
      if (expAccess - Date.now() / 1000 <= expDelay) {
        console.log('Need updateToken')
        success = (state.jwt.refresh) ? await dispatch('refreshToken') : false
      }
      if (!success) {
        commit('removeToken')
        router.push({ name: 'login' })
      }
      return success
    },

    FETCHuserProfile: async ({ getters, commit, dispatch }, { userId, phone }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      try {
        if (userId) {
          let response = await HTTP(getters.jwtAccess()).get(`auth/profile/${userId}`)
          return response.data
        } else if (phone) {
          let response = await HTTP(getters.jwtAccess()).get(`auth/profile/?phone=${phone}`)
          return response.data
        } else {
          let response = await HTTP(getters.jwtAccess()).get(`auth/profile/`)
          commit('SETuserProfile', response.data)
        }
      } catch (error) {
        console.log(error.response)
      }
    },

    POSTacceptance: async ({ getters, dispatch }, doc) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`acceptance/`, doc)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { status: success, data: data }
    },

    CANCELacceptance: async ({ getters, dispatch }, doc) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`cancelAcceptance/`, doc)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { status: success, data: data }
    },

    CANCELshipment: async ({ getters, dispatch }, doc) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`cancelShipment/`, doc)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { status: success, data: data }
    },

    CANCELtransfer: async ({ getters, dispatch }, doc) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`cancelTransfer/`, doc)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { status: success, data: data }
    },

    FETCHacceptance: async ({ getters, dispatch }, docId = null) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = docId
          ? await HTTP(getters.jwtAccess()).get(`acceptance/${docId}`)
          : await HTTP(getters.jwtAccess()).get(`acceptance/`)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    FETCHshipment: async ({ getters, dispatch }, docId = null) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = docId
          ? await HTTP(getters.jwtAccess()).get(`shipment/${docId}`)
          : await HTTP(getters.jwtAccess()).get(`shipment/`)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    POSTshipment: async ({ getters, dispatch }, doc) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`shipment/`, doc)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { status: success, data: data }
    },


    POSTtransfer: async ({ getters, dispatch }, doc) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`transfer/`, doc)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        console.log(error.response)
        data = error.response
      }
      return { status: success, data: data }
    },

    FETCHtransfer: async ({ getters, dispatch }, docId = null) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = docId
          ? await HTTP(getters.jwtAccess()).get(`transfer/${docId}`)
          : await HTTP(getters.jwtAccess()).get(`transfer/`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response.data
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    FETCHuserCards: async ({ getters, commit, dispatch }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      try {
        let response = await HTTP(getters.jwtAccess()).get(`cards/`)
        commit('SETuserCards', response.data)
      } catch (error) {
        console.log(error.response)
      }
    },

    FETCHberry: async ({ getters, commit, dispatch }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      try {
        let response = await HTTP(getters.jwtAccess()).get(`berry/`)
        commit('SETberry', response.data)
      } catch (error) {
        console.log(error.response)
      }
    },

    DELuserCard: async ({ getters, commit, dispatch }, cardId) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      try {
        let response = await HTTP(getters.jwtAccess()).delete(`cards/${cardId}`)
        if (response.status >= 200 && response.status < 300) {
          commit('DELuserCardItem', cardId)
          success = true
        }
      } catch (error) {
        console.log(error)
        console.log(error.response)
      }
      return success
    },

    POSTpayoffOrder: async ({ getters, commit, dispatch }, payoffOrder) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = {}
      try {
        let response = await HTTP(getters.jwtAccess()).post(`payofforder`, payoffOrder)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data

      } catch (error) {
        console.log('POSTpayoffOrder', error.response)
        data = error.response.data
      }
      return { status: success, data: data }
    },

    FETCHpayoffOrders: async ({ getters, commit, dispatch }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      try {
        let response = await HTTP(getters.jwtAccess()).get(`payofforders/`)
        commit('SETpayoffOrders', response.data)
      } catch (error) {
        console.log(error.response)
      }
    },

    FETCHuserBalance: async ({ getters, commit, dispatch }, userId) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      try {
        let response = await HTTP(getters.jwtAccess()).get(`balance/${userId}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          commit('SETuserBalance', response.data.balance)
        }
      } catch (error) {
        console.log(error.response)
      }
      return success
    },

    FETCHuser: async ({ getters, dispatch, commit }, userType) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = []
      try {
        let response = await AUTHjwt(getters.jwtAccess()).get(`user/${userType}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        console.log(error.response)
        success = false
      }
      return { status: success, data: data }
    },

    FETCHreceiverUsersForBerryResult: async ({ getters, dispatch, commit }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = []
      try {
        let response = await HTTP(getters.jwtAccess()).get(`receiverUsersForBerryResult`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        console.log(error.response)
        success = false
      }
      return { status: success, data: data }
    },

    FETCHroles: async ({ getters, dispatch, commit }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = []
      try {
        let response = await AUTHjwt(getters.jwtAccess()).get(`roles`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        console.log(error.response)
        success = false
        data = error.response
      }
      return { status: success, data: data }
    },

    FETCHresults: async ({ getters, dispatch, commit }, {dateFrom, dateTo}) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = []
      try {
        let response = await HTTP(getters.jwtAccess()).get(`results/dateFrom/${dateFrom}/dateTo/${dateTo}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        console.log(error.response)
        success = false
      }
      return { status: success, data: data }
    },

    FETCHacceptanceSum: async ({ getters, dispatch, commit }, receiverId) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = []
      try {
        let response = await HTTP(getters.jwtAccess()).get(`acceptanceSum/${receiverId}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        console.log(error.response)
        success = false
      }
      return { status: success, data: data }
    },

    FETCHtransferSum: async ({ getters, dispatch, commit }, receiverId) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = []
      try {
        let response = await HTTP(getters.jwtAccess()).get(`transferSum/${receiverId}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        console.log(error.response)
        success = false
      }
      return { status: success, data: data }
    },

    FETCHpassportImg: async ({ getters, dispatch, commit }, { page, userId }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = []
      try {
        let response = await HTTP(getters.jwtAccess()).get(`download/passport/${page}/${userId}`, { responseType: "arraybuffer", })
        if (response.status >= 200 && response.status < 300) {
          success = true
          let indexFilename = response.headers['content-disposition'].indexOf("filename=")
          let fileName = response.headers['content-disposition'].slice(indexFilename + 10, -1)
          data = {
            img: Buffer.from(response.data, "binary").toString("base64"),
            fileName: fileName,
            mimetype: response.headers['content-type'],
          }
        }
      } catch (error) {
        console.log('error', error.response)
        data = error.response
        success = false
      }
      return { status: success, data: data }
    },

    POSTuser: async ({ getters, dispatch }, user) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        user.passportImg = undefined
        response = await AUTHjwt(getters.jwtAccess()).post(`user/`, user)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        console.log(error.response)
        data = error.response
      }
      return { status: success, data: data }
    },

    SETcardDefault: async ({ getters, dispatch }, cardId) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`cards/${cardId}/setdefault`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          dispatch('FETCHuserCards')
        }
      } catch (error) {
        success = false
        console.log(error.response)
        data = error.response
      }
      return { status: success, data: data }
    },


    FETCHprices: async ({ getters, dispatch }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).get(`price`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response.data
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    POSTprice: async ({ getters, dispatch }, price) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`price`, price)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response.data
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    REMOVEprice: async ({ getters, dispatch }, priceId) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).delete(`price/${priceId}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    FETCHcurrentPrice: async ({ getters, dispatch }, {berryId, delivererId}) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        console.log('delivererId', delivererId);
        response = await HTTP(getters.jwtAccess()).get(`currentPrice/berry/${berryId}/deliverer/${delivererId}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    FETCHreceiverBonus: async ({ getters, dispatch }) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).get(`bonus`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    FETCHtransferPrice: async ({ getters, dispatch }, {weight, berry, receiverId, transferId, docType}) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        console.log(weight, berry, receiverId, transferId, docType)
        response = await HTTP(getters.jwtAccess()).get(`transferPrice/weight/${weight}/berry/${berry}/receiver/${receiverId}/transfer/${transferId}/docType/${docType}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
          console.log(response.data);
        }
      } catch (error) {
        success = false
        data = error.response
        console.log(error.response)
      }
      return { 'status': success, 'data': data }
    },

    FETCHreportMaster: async ({ getters, dispatch }, {dateFrom, dateTo, receiverId, berryId}) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).get(`reportMaster/receiver/${receiverId}/berry/${berryId}/datefrom/${dateFrom}/dateto/${dateTo}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response
        console.log(error)
      }
      return { 'status': success, 'data': data }
    },

    FETCHreportReceiver: async ({ getters, dispatch }, {dateFrom, dateTo, receiverId}) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).get(`reportReceiver/receiver/${receiverId}/datefrom/${dateFrom}/dateto/${dateTo}`)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response
        console.log(error)
      }
      return { 'status': success, 'data': data }
    },

    CANCELаcceptances: async ({ getters, dispatch }, payload) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`cancelAcceptances/`, payload)
        if (response.status >= 200 && response.status < 300) {
          success = true
          data = response.data
        }
      } catch (error) {
        success = false
        data = error.response
        console.log(error)
      }
      return { 'status': success, 'data': data }
    },

    RECALCtransfer: async ({ getters, dispatch }, doc) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`recalcTransfer/`, doc)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        console.log(error.response)
        data = error.response
      }
      return { status: success, data: data }
    },


    POSTWriteoffBalance: async ({ getters, dispatch }, doc) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success, response, data
      try {
        response = await HTTP(getters.jwtAccess()).post(`writeOffBalance/`, doc)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data
      } catch (error) {
        success = false
        console.log(error.response)
        data = error.response
      }
      return { status: success, data: data }
    },

    POSTberry: async ({ getters, dispatch }, berry) => {
      (getters.jwtAccessValid()) ? true : await dispatch('inspectToken')
      var success = false
      var data = {}
      try {
        let response = await HTTP(getters.jwtAccess()).post(`berryPost`, berry)
        if (response.status >= 200 && response.status < 300) {
          success = true
        }
        data = response.data

      } catch (error) {
        console.log('POSTberry', error.response)
        data = error.response.data
      }
      return { status: success, data: data }
    },


  }
})
